import React from "react";

export class AlertModal extends React.Component {
  render() {
    if (!this.props.show) {
      return null;
    }

    return (
      <div className="app-modal-overlay">
        <div className="app-modal">
          <p className="app-modal-message">{this.props.message}</p>
          <div className="app-modal-actions">
            <button
              type="button"
              className="btn-default app-modal-btn"
              onClick={this.props.onClose}
            >
              {this.props.closeLabel || "OK"}
            </button>
          </div>
        </div>
      </div>
    );
  }
}
